import { Chip, Box } from "@mui/joy";
import { FormHelperText, FormLabel } from "@mui/joy";
import { useEffect } from "react";
import { useController, useFormContext } from "react-hook-form";

import { useRoutesUiStore } from "@/components/RoutesProvider";

import { Route } from "../../core/types";
import { useCurrentVenueMapsByUuidQuery } from "../../hooks/venues";
import FormGroup from "./FormGroup";

export default function MapPositionEditInput({
  route,
}: {
  route?: Partial<Route> & { uuid: string };
}) {
  const { control } = useFormContext<{
    mapPosition: { x: number; y: number } | null;
    map: string | null;
  }>();
  const { field: mapPositionField, fieldState: mapPositionFieldState } = useController({
    control,
    name: "mapPosition",
  });
  const { field: mapField, fieldState: mapFieldState } = useController({
    control,
    name: "map",
  });

  const mapPositionEdits = useRoutesUiStore((state) => state.mapPositionEdits);

  const mapPositionEditForRoute = route ? mapPositionEdits[route?.uuid] : undefined;

  useEffect(() => {
    if (mapPositionEditForRoute) {
      mapPositionField.onChange({
        x: mapPositionEditForRoute.x,
        y: mapPositionEditForRoute.y,
      });
      mapField.onChange(mapPositionEditForRoute.map);
    }
  }, [mapPositionEditForRoute]);

  const { data: maps } = useCurrentVenueMapsByUuidQuery();

  return (
    <FormGroup error={!!(mapPositionFieldState.error || mapFieldState.error)}>
      <FormLabel>Map and Position</FormLabel>
      <Box
        sx={{
          fontStyle: "italic",
          fontSize: "sm",
          color: "grey",
          marginTop: -0.5,
          marginBottom: 1,
        }}
      >
        Drag the route on the map to move it around.
      </Box>
      {mapField.value && <Chip>{maps?.[mapField.value]?.name}</Chip>}
      {(mapPositionFieldState.error || mapFieldState.error) && (
        <FormHelperText>
          {mapPositionFieldState.error?.message || mapPositionFieldState.error?.message}
        </FormHelperText>
      )}
    </FormGroup>
  );
}
